import isArray from 'lodash/isArray';
import each from 'lodash/each';
import { eliteGuestQueryParam } from './personalization/eliteGuestQueryParam';
import { loggedInUser } from './personalization/loggedInUser';
import { interactionStudioApi } from './personalization/interactionStudioApi';

//when adding new personalizations add to subscriptions object and subscribe function

//each subscription is required to have getPromise() fn, and should have isLazy value to be clear when promise is run
const subscriptions = {
	eliteGuestQueryParam,
	loggedInUser,
	interactionStudioApi,
};
let loadedSubscriptions = {};
each(subscriptions, (subscription, key) => {
	subscriptions[key] = () => {
		if (!loadedSubscriptions[key]) {
			loadedSubscriptions[key] = subscription();
		}
		return loadedSubscriptions[key];
	};
});

const validateKeys = keys => {
	if (keys) {
		keys = isArray(keys) ? keys : [keys];
	} else {
		keys = Object.keys(subscriptions);
	}
	return keys;
};

export const resolvePersonalizations = (keys, callback) => {
	if (typeof keys === 'function') {
		callback = keys;
		keys = null;
	}
	if (!callback || typeof callback !== 'function') {
		callback = () => {};
	}
	keys = validateKeys(keys);
	const promises = [];
	keys.forEach(key => {
		promises.push(subscriptions[key]());
	});
	Promise.all(promises).then(personalizationResults => {
		const results = {};
		let i = 0;
		keys.forEach(key => {
			results[key] = personalizationResults[i];
			i++;
		});
		callback(results);
	});
};
